import { render, staticRenderFns } from "./PeriodSalesTable.vue?vue&type=template&id=17e1b3b8&"
import script from "./PeriodSalesTable.vue?vue&type=script&lang=js&"
export * from "./PeriodSalesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/zp_frontend_vuejs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17e1b3b8')) {
      api.createRecord('17e1b3b8', component.options)
    } else {
      api.reload('17e1b3b8', component.options)
    }
    module.hot.accept("./PeriodSalesTable.vue?vue&type=template&id=17e1b3b8&", function () {
      api.rerender('17e1b3b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Dashboard/PeriodSalesTable.vue"
export default component.exports